import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../site/Navbar";
import Hero from "../site/Hero";
import About from "../site/About";
import Gallery from "../site/Gallery";
import Amenities from "../site/Amenities";
import Services from "../site/Services";
import Contact from "../site/Contact";
import Footer from "../site/Footer";
import PromoBanner from "../site/PromoBanner";
import { api } from "../lib/api";

export default function Landing() {
  const [settings, setSettings] = React.useState(null);
  const [promos, setPromos] = React.useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data || {})).catch(() => {});
    api.get("/promos").then((r) => setPromos(r.data || [])).catch(() => {});
  }, []);

  React.useEffect(() => {
    const anchor = location.state?.anchor;
    if (!anchor) return;
    if (anchor === "schedule") {
      navigate("/schedule");
      return;
    }
    setTimeout(() => {
      if (anchor === "top") window.scrollTo({ top: 0, behavior: "smooth" });
      else document.getElementById(anchor)?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  }, [location.state, navigate]);

  // Support direct hash links like /#schedule, /#book, /#booking → redirect to /schedule
  React.useEffect(() => {
    const raw = (location.hash || "").replace("#", "").toLowerCase();
    if (!raw) return;
    if (["schedule", "book", "booking", "reserve"].includes(raw)) {
      navigate("/schedule", { replace: true });
      return;
    }
    setTimeout(() => {
      document.getElementById(raw)?.scrollIntoView({ behavior: "smooth" });
    }, 400);
  }, [location.hash, navigate]);

  return (
    <div className="bg-[#0A0B10] text-white" data-testid="landing-page">
      <Navbar />
      <Hero settings={settings} />
      <About settings={settings} />
      <Gallery />
      <Amenities />
      <Services />
      <Contact settings={settings} />
      <Footer settings={settings} />
      <PromoBanner promos={promos} />
    </div>
  );
}
